import React from 'react';
import { Routes, Route } from 'react-router-dom';

const SptpManage = React.lazy(() => import('pages/sptp/manage/SptpManageMain'));
const SptpCheckUpManage = React.lazy(() => import('pages/sptp/checkup/SptpCheckUpManage'));
const SptpCheckUpManageAdd = React.lazy(() => import('pages/sptp/checkup/SptpCheckUpManageAdd'));
const SptpCheckUpManageEdit = React.lazy(() => import('pages/sptp/checkup/SptpCheckUpManageEdit'));
const SptpInquiry = React.lazy(() => import('pages/sptp/inquiry/SptpInquiry'));
const SptpInquiryDetail = React.lazy(() => import('pages/sptp/inquiry/SptpInquiryDetail'));

export const URL_SPTP_MANAGER = '/sptpManager';

export const URL_SPTP = '/sptp';
export const URL_SPTP_MANAGE = `${URL_SPTP}/manage`; // SPTP 관리
export const URL_SPTP_CHECK_UP_MANAGE = `${URL_SPTP}/checkup-manage`; // 검사문항 관리
export const URL_SPTP_CHECK_UP_MANAGE_ADD = `${URL_SPTP_CHECK_UP_MANAGE}/add`; // 검사문항 관리 등록
export const URL_SPTP_CHECK_UP_MANAGE_EDIT = `${URL_SPTP_CHECK_UP_MANAGE}/edit/:no`; // 검사문항 관리 수정
export const URL_SPTP_INQUIRY = `${URL_SPTP}/inquiry`; // SPTP 문의
export const URL_SPTP_INQUIRY_DETAIL = `${URL_SPTP_INQUIRY}/:no`; // SPTP 문의 상세
export const URL_SPTP_INQUIRY_ADD = `${URL_SPTP_INQUIRY}/add`; // SPTP 문의 등록
export const URL_SPTP_INQUIRY_EDIT = `${URL_SPTP_INQUIRY}/edit/:no`; // SPTP 문의 수정

/**
 * SPTP
 * @returns
 */
const SptpRoute = ({ common }) => {
  return (
    <Routes>
      <Route path={URL_SPTP_MANAGE} element={<SptpManage common={common} />} />
      <Route path={URL_SPTP_CHECK_UP_MANAGE} element={<SptpCheckUpManage common={common} />} />
      <Route path={URL_SPTP_CHECK_UP_MANAGE_ADD} element={<SptpCheckUpManageAdd common={common} />} />
      <Route path={URL_SPTP_CHECK_UP_MANAGE_EDIT} element={<SptpCheckUpManageEdit common={common} />} />
      <Route path={URL_SPTP_INQUIRY} element={<SptpInquiry common={common} />} />
      <Route path={URL_SPTP_INQUIRY_DETAIL} element={<SptpInquiryDetail common={common} />} />
    </Routes>
  );
};

export default SptpRoute;
